import { Observable } from 'rxjs';
import { RewardBalance, RewardToken } from '../reward-balance.model';

export abstract class RewardsProgramGateway {
  abstract getToken(userId?: number): Observable<RewardToken>;
  abstract getBalance(userId?: number): Observable<RewardBalance>;
}
